export default "__VITE_ASSET__BC8H98BD__"